import { stateKey } from '../../../../../app/state-key.js';
import { registerCategoryFacetSearch, selectCategoryFacetSearchResult, } from '../../../../../features/facets/facet-search-set/category/category-facet-search-actions.js';
import { defaultFacetSearchOptions } from '../../../../../features/facets/facet-search-set/facet-search-reducer-helpers.js';
import { buildGenericFacetSearch } from '../facet-search.js';
export function buildCoreCategoryFacetSearch(engine, props) {
    const { dispatch } = engine;
    const options = { ...defaultFacetSearchOptions, ...props.options };
    const { facetId } = options;
    const getFacetSearch = () => 'state' in engine
        ? engine.state.categoryFacetSearchSet[facetId]
        : engine[stateKey].categoryFacetSearchSet[facetId];
    dispatch(registerCategoryFacetSearch(options));
    const genericFacetSearch = buildGenericFacetSearch(engine, {
        options,
        getFacetSearch,
        isForFieldSuggestions: props.isForFieldSuggestions,
        executeFacetSearchActionCreator: props.executeFacetSearchActionCreator,
        executeFieldSuggestActionCreator: props.executeFieldSuggestActionCreator,
    });
    return {
        ...genericFacetSearch,
        select(value) {
            dispatch(selectCategoryFacetSearchResult({
                facetId,
                value,
            }));
            props.select(value);
        },
        get state() {
            return genericFacetSearch.state;
        },
    };
}
